<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["LOGRPT"]["ALOG"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="dd_agentgroup"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAGI"
                                                  @input="AgentGroupChangefs"/>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="str_FV[6].FV"
                                            @input="SubAgentGroupChangefs"
                                            openDirection="below" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["LOGRPT"]["OP"]}} :</span>
                                <CInput size="sm"
                                        :value="str_FV[1].FV" @change="v => str_FV[1].FV = v" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="str_FV[3].FV" />
                            </div>
                            <!--<div class='searchCol'>
        <span class='searchLabel'>{{this.getLanguage["LOGRPT"]["DEV"]}} :</span>
        <treeselect :multiple="false"
                    :options="ddDeviceTypeList"
                    :placeholder="this.utilGetDDLanguage('LOGRPT.DEV')"
                    v-model="str_FV[4].FV" />
    </div>-->

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["LOGRPT"]["ACT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="loglist"
                                            :placeholder="this.utilGetDDLanguage('LOGRPT.ACT')"
                                            v-model="str_FV[5].FV"/>
                            </div>

                            <!--RoleAccess-->
                            <div v-if="loglist[str_FV[5].FV] && loglist[str_FV[5].FV].label === this.getLanguage['AC']['SuperAdminAssign']" class='searchExpandCol2'>
                                <span class='searchLabel'>{{this.getLanguage['AG']['RA']}} :</span>
                                <treeselect :multiple="false"                                                                                        
                                            :options="dd_roleaccess"                                            
                                            :placeholder="this.utilGetDDLanguage('LOGRPT.ACT')"
                                            v-model="searchRoleAccess" />
                            </div>

                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <div>
                        <strong>
                            {{this.getLanguage['LOGRPT']['ALL']}}
                        </strong>
                        <span class="ml-2">
                            <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-user-shield theme-agent mr-1" style="color:blue"></i> <strong>{{ getLanguage["AG"]["SSA"] }}</strong></span>
                            <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fas fa-user theme-agent mr-1"></i> <strong>{{ getLanguageOEMI(this.getUserInfo.OEMI,"AG","A") }}</strong></span>
                            <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                            <span v-if="getUserInfo.OEMI != 2" style=" border-right: solid 1px; padding-right: 5px;"><i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                            <span><span class="subagent-icon mr-1" style="background: #0c1033 !important; padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                        </span>
                    </div>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['GL']['AGT']}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')"  class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['U']}}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['LT']}}<i @click="setSortTable('LTS')" :class="setSortLogo('LTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['OP']}}<i @click="setSortTable('LB')" :class="setSortLogo('LB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['ACT']}}<i @click="setSortTable('LA')" :class="setSortLogo('LA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['AMT']}}<i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GL']['IP']}}<i @click="setSortTable('IPA')" :class="setSortLogo('IPA')" class="sortlogo"></i></th>

                                <!--<th>{{this.getLanguage['LOGRPT']['DEV']}}<i @click="setSortTable('IM')" :class="setSortLogo('IM')"></i></th>-->
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['GL']['AGT']}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['U']}}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['LT']}}<i @click="setSortTable('LTS')" :class="setSortLogo('LTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['OP']}}<i @click="setSortTable('LB')" :class="setSortLogo('LB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['ACT']}}<i @click="setSortTable('LA')" :class="setSortLogo('LA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['LOGRPT']['AMT']}}<i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GL']['IP']}}<i @click="setSortTable('IPA')" :class="setSortLogo('IPA')" class="sortlogo"></i></th>

                                <!--<th>{{this.getLanguage['LOGRPT']['DEV']}}<i @click="setSortTable('IM')" :class="setSortLogo('IM')"></i></th>-->
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_all.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_all" :class="data.MS == 1? 'blacklist-row': data.MS == 3? 'freeze-row': ''">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <span>
                                    <i class="fas fa-user-shield theme-agent" style="color:blue" v-if="data.AT==0"></i>
                                    <i class="fas fa-user theme-agent" v-else-if="data.AL==0"></i>
                                    <i class=" " v-else :class="[data.IOL?'fa-solid fa-house theme-outlet':'fas fa-users theme-subagent']"></i>
                                    <span v-if="data.AT==0" class="subagent-icon agent" style="background:blue">SA</span>
                                    <span v-else-if="data.AL==0" class="subagent-icon agent">A</span>
                                    <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                    {{ data.GN }} ({{ data.GPC }})
                                </span>
                            </td>
                            <td v-if="data.ISU && data.U">
                                {{ data.U }}
                            </td>
                            <td v-else-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" :class="data.U != null && data.U != '' ? 'kema-eft': ''" @click="CheckingMember(data.AGI,data.MI)">
                                <span class="grid-line" v-if="data.U != null && data.U != ''">
                                    <div class="custom_tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.TW == 0">
                                        <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.HTWT">
                                        <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.RP">
                                        <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td v-else-if="(isSENS == 1 && data.AGI != curAGI)" :class="data.U != null && data.U != '' ? 'kema-eft': ''">
                                <span class="grid-line" v-if="data.U != null && data.U != ''">
                                    <div class="custom_tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.TW == 0">
                                        <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.HTWT">
                                        <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.RP">
                                        <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>{{ formatDateTime(data.LTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.LB }}</td>
                            <td>{{ renderAction(data.LA) }}</td>
                            <td>
                                <span v-if="data.TA == 0">-</span>
                                <span v-else>{{ formatNumber(data.TA, 2, data.CS) }}</span>
                            </td>
                            <td>{{ data.IPA }}</td>

                            <!--<td>{{ getDevice(data.IM) }}</td>-->
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { consDeviceType, loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "LTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "LB" }, {
                    F: "LTS", FV: {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    }
                }, { F: "MI" }, { F: "IM" }, { F: "LA" }, { F: "SAGI"}], //Filter Value
                arry_all: [], //agent log list
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],//subagent default group option
                searchAGI: null,
                rtSubBrand: 0,
                ddDeviceTypeList: consDeviceType,
                dd_dofs: [],
                ddMemberList: [],                
                loglist: [],
                dd_roleaccess: [],
                searchRoleAccess: null                
            }
        },
        created() {
            this.$parent.showSubMenu = 'L';
            this.$parent.showActiveMenu = 'L.ALO';
            this.getAgentLogAction(this.getUserInfo.AGI);
            this.getAgentLogList();            
            this.getAgentGroup();
            this.getAgentGroupDropdown();
            this.getSubAgentGroupDropdown(this.getUserInfo.AGI, true);

            if (this.getUserInfo.AT === 0) {
                this.getRoleAccessDropdown(this.getUserInfo.AGI);
            }
            
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getAgentLogList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getAgentLogList();
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            CheckingMember(agi, mi) {
                if (mi != null && mi != 0 && mi != "") {
                    let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                    window.open(routeData.href, '_blank');
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);                    
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.str_FV[0].FV}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;                                
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_agentgroup = d.dropdownlist;
                        }
                        else {
                            that.dd_agentgroup = null;
                        }

                        callback();
                    });
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    //var that = this;
                    var agi = 0;
                    if (value != "") {
                        agi = value.split("-")[1];
                        this.str_FV["0"].FV = agi;                        
                        this.str_FV["6"].FV = null;
                    }
                }
                else {
                    this.str_FV["0"].FV = null;
                    this.str_FV["6"].FV = null;
                }
            },
            
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            //if (that.dd_agentgroup && that.dd_agentgroup.length > 0) {
                            //    that.str_FV["0"].FV = that.dd_agentgroup[0].id;
                            //}                            
                        }
                    });
            },
            getSubAgentGroupDropdown(value, isFirstLoad = false) {
                if ((isFirstLoad && this.getUserInfo.AT > 3) || !isFirstLoad) {
                    var that = this;
                    this.getDataApi(`/api/dd/subbrand/0/0/${value}/1/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                if (isFirstLoad) {
                                    that.dd_DefaultSubBrandSearch = that.deepClone(d.dropdownlist);
                                    that.str_FV["6"].FV = that.dd_DefaultSubBrandSearch[0].id;
                                    that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                    that.getList();
                                    
                                }
                                else {
                                    that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);
                                    that.rtSubBrandEdit = that.rtSubBrandEdit == 0 ? 1 : 0;
                                }
                            }
                        });
                }
            },            
            getRoleAccessDropdown(agi) {
                var that = this;

                this.getDataApi(`/api/dd/saara/${agi}`, function (d, s) {
                    if (s && d && d.dropdownlist) {                        

                        const filteredAccessName = [];                       

                        for (var i = 0; i < d.dropdownlist.length; i++) {
                            const currentItem = d.dropdownlist[i];
                            currentItem.label = that.renderAccessName(currentItem);
                            filteredAccessName.push(currentItem);
                        }

                        that.dd_roleaccess = filteredAccessName;

                    }
                    else {
                        that.dd_roleaccess = [];
                    }
                });
            },
            renderAccessName(accessName) {                
                const accessT = this.getLanguage['BTN'];
                const smb = this.getLanguage['SMB'];

                const accessType = {
                    '1': accessT['V'],
                    '2': accessT['AD'],
                    '3': accessT['ED'],
                    '4': accessT['DLT']
                };

                const accessRight = accessType[accessName.extra] || "";

                const labelName = (accessName.label2 && accessName.label2 in smb) ? smb[accessName.label2] : accessName.label2 || "";

                return labelName + " - " + accessRight;
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }

                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.str_FV["6"].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV["6"].FV = null;
                }
            },

            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.str_FV["0"].FV) {
                    var agentList = this.str_FV["0"].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },

            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            getAgentLogAction(agi) {
                var that = this;                

                this.getDataApi(`/api/dd/gal/${agi}`,
                    function (d, s) {                        
                        if (s && d && d.dropdownlist) {                            
                            const filteredAction = [];

                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                const currentItem = d.dropdownlist[i];
                                currentItem.label = that.renderAction(currentItem.label);
                                filteredAction.push(currentItem);
                            }

                            that.loglist = filteredAction;                            
                        }
                        else {
                            that.loglist = null;
                        }                       
                    });
            },            
            getAgentLogList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);                

                //search
                if (this.str_FV) {
                    if (path) {
                        path += "&";
                    }
                    path += (
                        "f[LB]=" + (this.str_FV[1].FV == null ? "" : this.str_FV[1].FV) +
                        "&f[MI]=" + (this.str_FV[3].FV == null ? "" : this.str_FV[3].FV)                        
                    );                    

                    if (this.str_FV[5].FV && this.searchRoleAccess) {
                        path += "&f[LA]=" + this.searchRoleAccess;
                    }
                    else {
                        this.searchRoleAccess = null;                        
                        path += "&f[LA]=" + (this.str_FV[5].FV == null ? "" : that.loglist[this.str_FV[5].FV].label2);
                    }                    

                    if (this.str_FV[6].FV) {
                        path += "&f[AGI]=" + (this.str_FV[6].FV == null ? "" : this.str_FV[6].FV);
                    } else if (this.str_FV[0].FV) {
                        path += "&f[AGI]=" + (this.str_FV[0].FV == null ? "" : this.str_FV[0].FV);
                    }

                    if (this.str_FV[2].FV.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.str_FV[2].FV.startDate);
                        path += "&f[LTS_from]=" + cts_from;
                    }
                    if (this.str_FV[2].FV.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.str_FV[2].FV.endDate);
                        path += "&f[LTS_to]=" + cts_to;
                    }
                }               

                this.getDataApi(`/api/logs/agent?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAgentLogList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setAgentLogList(data) {
                this.arry_all = data.Items;                
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getAgentLogList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            getDevice(data) {
                var status = '';
                if (data.IM == 1) {
                    status = this.getLanguage['DEV']['M'];
                }
                else {
                    status = this.getLanguage['DEV']['D'];
                }

                return status;
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },       
        watch: {
            getLanguage() {
                this.getAgentLogList();
                this.getAgentLogAction(this.getUserInfo.AGI);
                if (this.getUserInfo.AT === 0) {
                    this.getRoleAccessDropdown(this.getUserInfo.AGI);
                }
            },            
        },
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Logs/AgentLogs.vue